export default "__VITE_ASSET__d5bpFE72__"